import React, { useEffect, useState, Dispatch, SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';
import { popupOpenService } from '../../services/popupOpenService';
import { POPUP_KEY_DELETE_COOKING_STEP } from '../../constant';
import { MODAL_SMALL_SIZE } from '../helper';
import { cookingStepSaveService } from '../../services/cookingStepSaveService';
import { Button } from '@chapche/ui';

type DeleteModalContentProps = {
    handleDelete: () => void;
    handleClose: Dispatch<SetStateAction<boolean | null>>;
};

const DeleteModalContent: React.FC<DeleteModalContentProps> = ({ handleDelete, handleClose }) => {
    const { i18n } = useTranslation();
    return (
        <>
            <h2 className="modal__title modal__title_align block__title-h3">
                {i18n.t('app.page.cookingStep.modal.delete.title')}
            </h2>
            <p className="block__content modal__text modal__text_align">
                {i18n.t('app.page.cookingStep.modal.delete.content')}
            </p>
            <div className="modal__button-group">
                <Button variant="outline" onClick={() => handleClose(null)}>
                    {i18n.t('app.page.cookingStep.modal.cancel')}
                </Button>
                <Button onClick={handleDelete}>
                    {i18n.t('app.page.cookingStep.modal.delete.delete')}
                </Button>
            </div>
        </>
    );
};

type DeleteCookingStepPopupProps = {
    onDeleted?: (deletedId: string, nextSelectedId: string | null) => void;
};

const DeleteCookingStepPopup: React.FC<DeleteCookingStepPopupProps> = ({ onDeleted }) => {
    const [isOpen, setIsOpen] = useState<boolean | null>(false);
    const [stepId, setStepId] = useState('');

    useEffect(() => {
        const open = (id: string) => {
            setIsOpen(true);
            setStepId(id);
        };
        popupOpenService.registerPopup(POPUP_KEY_DELETE_COOKING_STEP, open);
        return () => popupOpenService.unRegisterPopup(POPUP_KEY_DELETE_COOKING_STEP);
    }, []);

    const deleteStep = () => {
        const deletedId = stepId;
        const current = [...cookingStepSaveService.getSteps()].sort(
            (a, b) => (a.stepOrder || 0) - (b.stepOrder || 0),
        );
        const index = current.findIndex((step) => step.id === deletedId);
        const neighbor = index >= 0
            ? (current[index + 1] || current[index - 1] || null)
            : null;
        const nextSelectedId = neighbor?.id || null;

        setIsOpen(null);
        setStepId('');
        cookingStepSaveService.deleteStep(deletedId, () => {
            onDeleted?.(deletedId, nextSelectedId);
        });
    };

    return isOpen ? (
        <Modal
            content={<DeleteModalContent handleDelete={deleteStep} handleClose={setIsOpen} />}
            handleCloseModal={setIsOpen}
            size={MODAL_SMALL_SIZE}
        />
    ) : null;
};

export default DeleteCookingStepPopup;
